import cloneDeep from 'lodash.clonedeep';

const ChartConfigPropertyKey = {
  Type: 'type',
  Width: 'width',
  Id: 'id',
};

const DEFAULT_CHART_CONFIG = {
  height: 400,
  type: 'line',
  stacked: false,
  toolbar: {
    export: {
      csv: {
        headerCategory: 'Start Date',
      },
    },
  },
};

export default class ChartConfigBuilder {
  #config = cloneDeep(DEFAULT_CHART_CONFIG);

  setWidth(width) {
    return this.#setProperty(ChartConfigPropertyKey.Width, width);
  }

  setId(name) {
    this.#setProperty(ChartConfigPropertyKey.Id, `${name} Graph`);
    this.#config.toolbar.export.csv.filename = `${name} Spreadsheet`;
  }

  build() {
    return this.#config;
  }

  #setProperty(propertyName, value) {
    this.#config[propertyName] = value;

    return this;
  }
}
